import { ContentHeader, MainContentArea } from "melco-ui";
import { useTranslation } from "react-i18next";
import { SummitWorkspace } from "../../components/summit/SummitWorkspace";

export const Summit: React.FC = () => {
  const { t } = useTranslation();


  return (
    <MainContentArea
      header={
        <ContentHeader
          title={t("main_menu.summit")}

        />
      }
    >
      <SummitWorkspace />

    </MainContentArea >
  );
};
